export default __webpack_public_path__ + "static/media/close.1fc84c81.svg";